module.exports = __webpack_public_path__ + "img/certificate8.9117aa6d.png";